
















































import { Component, Vue } from "vue-property-decorator";
import Headings from "./Styleguide/Headings.vue";
import Icons from "./Styleguide/Icons.vue";
import Buttons from "./Styleguide/Buttons.vue";
import Tooltips from "./Styleguide/Tooltips.vue";
import Badges from "./Styleguide/Badges.vue";
import FormControls from "./Styleguide/FormControls.vue";
import CustomControls from "./Styleguide/CustomControls.vue";
import Lists from "./Styleguide/Lists.vue";
import Charts from "./Styleguide/Charts.vue";
import Modals from "./Styleguide/Modals.vue";
import Tables from "./Styleguide/Tables.vue";
import Other from "./Styleguide/Other.vue";

@Component({
  components: {
    Headings,
    Icons,
    Buttons,
    Tooltips,
    Badges,
    FormControls,
    CustomControls,
    Lists,
    Charts,
    Modals,
    Tables,
    Other,
  },
})
export default class Styleguide extends Vue {}
